import { cn } from '@/lib/utils'
import { useTranslation } from 'react-i18next'
import { BaseDialog } from './BaseDialog'
import { Button } from './ui/button'
import { Spinner } from './ui/spinner'

export function FormDialog({
  open,
  onOpenChange,
  title,
  children,
  onSubmit,
  isLoading,
  isInvalid,
  submitLabel,
  dialogContentClass,
  contentTestId,
  submitTestId,
}: {
  open: boolean
  onOpenChange: (v: boolean) => void
  title: string
  children: React.ReactNode
  onSubmit?: () => void
  isLoading?: boolean
  isInvalid?: boolean
  submitLabel?: string
  dialogContentClass?: string
  contentTestId?: string
  submitTestId?: string
}) {
  const { t } = useTranslation()
  return (
    <BaseDialog
      open={open}
      onOpenChange={onOpenChange}
      title={title}
      isLoading={isLoading}
      dialogContentClass={dialogContentClass}
      contentTestId={contentTestId}
      footer={
        <>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            {t('common.cancel')}
          </Button>

          <Button data-testid={submitTestId ?? 'form-dialog-submit'} onClick={onSubmit} disabled={isLoading || isInvalid}>
            {isLoading && <Spinner />}
            {submitLabel ?? t('common.save')}
          </Button>
        </>
      }
    >
      <fieldset disabled={isLoading} className={cn('flex flex-col gap-4 py-2', isLoading && 'opacity-70')}>
        {children}
      </fieldset>
    </BaseDialog>
  )
}
